import { useAuth0 } from '@auth0/auth0-react'
import { useAnimatedAlert } from '~components/molecules/animated-alert/animated-alert-provider'
import { localStorageItemKeys } from '~constants/local-storage-items'
import { Option } from '~pages/pages-behind-login/profile-page/profile-page'

export function useFetch<T = unknown>() {
  const { getAccessTokenSilently } = useAuth0()
  const { setStatus } = useAnimatedAlert()

  async function fetchRequest(
    requestUrl: string,
    options?: RequestInit,
    payload?: unknown,
    method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH' = 'GET',
    formData?: FormData,
  ): Promise<T> {
    const token = await getAccessTokenSilently()
    const impersonate: Option | undefined = localStorage.getItem(
      localStorageItemKeys.impersonate,
    )
      ? JSON.parse(
          localStorage.getItem(localStorageItemKeys.impersonate) as string,
        )
      : undefined

    const headers: HeadersInit = {
      Authorization: `Bearer ${token}`,
    }

    if (impersonate?.id) {
      headers['x-impersonate'] = impersonate.id
    }

    if (!formData) {
      headers['Content-Type'] = 'application/json'
    }

    const response = await fetch(requestUrl, {
      method,
      headers,
      ...options,
      body: formData || JSON.stringify(payload),
    })
    if (response.status === 401 || response.status === 403) {
      console.log('here')
      setStatus("You're not authorized to perform this action.", 5000, 'error')
    } else if (!response.ok) {
      throw new Error('something went wrong')
    }
    const contentType = response.headers.get('content-type')
    if (contentType?.includes('application/json')) {
      return response.json()
    } else {
      return response.text() as unknown as T
    }
  }

  return fetchRequest
}
